import axios from "axios";
import { Global } from '../utils/general';
import headerRequest from "../utils/headers"

const API_URL = Global.url;

class EquipmentStateService {
    getEquipmentState(url) {
        let ruta = `${API_URL}/equipment-state?url=${url}`;
        return axios.get(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }
}

export default new EquipmentStateService();
